const ROOTS = {
  DASHBOARD: "",
};
export const paths = {
  dashboard: {
    root: ROOTS.DASHBOARD,
    // employers: `${ROOTS.DASHBOARD}/employers`,
    // employees: `${ROOTS.DASHBOARD}/employees`,
    // networks: `${ROOTS.DASHBOARD}/networks`,
    // providers: `${ROOTS.DASHBOARD}/providers`,
    // services: `${ROOTS.DASHBOARD}/services`,
    // transfers: `${ROOTS.DASHBOARD}/transfers`,
    // visits: `${ROOTS.DASHBOARD}/visits`,
    // documents: `${ROOTS.DASHBOARD}/documents`,
    // tasks: `${ROOTS.DASHBOARD}/tasks`,
    // users: `${ROOTS.DASHBOARD}/users`,
  },
  /*
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
  }, */
};
